module.exports = __webpack_public_path__ + "static/media/Externer Verkauf.f3c52533.png";